import { makeObservable, action, observable, runInAction } from 'mobx';
import { BaseService } from '../base';
import DisbursementWorks from './api.interface';
import { DisbursementWorksModel } from './model';

export class DisbursementWorksService extends BaseService {
  @observable info: DisbursementWorksModel = new DisbursementWorksModel();

  constructor() {
    super();
    makeObservable(this);
  }

  /**
   * @description 查询 How Disbursement Works 页试算数据(QueryDisbursementWorksPage / BFF 6.11)
   * 后端字段沿用 snake_case，直接透传赋值。
   */
  @action
  async getDisbursementWorks() {
    const { code, result } = await this.post(DisbursementWorks.API.get_disbursement_works);
    if (code !== 0) {
      return false;
    }
    runInAction(() => {
      this.info = { ...result } as DisbursementWorksModel;
    });
    return true;
  }
}
